var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestaurantWhite1212 = function SvgRestaurantWhite1212(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.75 6.2a2.5 2.5 0 1 0-1 0v4.05a.5.5 0 0 0 1 0zM9.25 3.737V1.75a.5.5 0 0 0-1 0v1.987a.5.5 0 0 1-1 0V1.75a.5.5 0 0 0-1 0v2.487A2.01 2.01 0 0 0 8.125 6.25h.125v4a.5.5 0 0 0 1 0v-4h.125a2.01 2.01 0 0 0 1.875-2.013V1.75a.5.5 0 0 0-1 0v1.987a.5.5 0 0 1-1 0",
    clipRule: "evenodd"
  })));
};
export default SvgRestaurantWhite1212;